import React from 'react';

import PropTypes from 'prop-types';
import MultiSelect from './multiSelect';

import { useLocalizedStringsContext } from '../../../../context/LocalizedStringsContext';

const FilterByAccountStatus = ({ filters, setFilters }) => {
  const localizedStrings = useLocalizedStringsContext();
  const {
    ORDERS: { filterByAccountStatus }
  } = localizedStrings;
  const options = [
    { label: 'Approved', value: 'APPROVED' },
    { label: 'Pending Approval', value: 'PENDING_APPROVAL' },
    { label: 'Disabled', value: 'DISABLED' },
    { label: 'Deleted', value: 'DELETED' }
  ];

  return (
    <div>
      <MultiSelect
        updateFilters={value => {
          setFilters({ ...filters, accountStatus: value });
        }}
        label={filterByAccountStatus}
        options={options}
        value={filters.accountStatus}
      />
    </div>
  );
};

FilterByAccountStatus.propTypes = {
  filters: PropTypes.objectOf(PropTypes.shape({})).isRequired,
  setFilters: PropTypes.func.isRequired
};

export default FilterByAccountStatus;
